import styled, { css } from 'styled-components';
import { Modal } from 'react-bootstrap';

const LaunchchallengeButton = styled.div`
  width: 100%;
  height: 50px;
  background: white;
  border-radius: 6px;
  display: flex;
  cursor: pointer;
  width: 328px;
  background:linear-gradient(90deg, rgb(0, 111, 188) -1.11%, rgb(127, 67, 255) 97.46%);
  .image{
    width: 15%;
    display: flex;
    padding-left: 3px;
    margin: auto;
    >img{
      max-width: 44px;
      max-height: 44px;
    }
  }
  .text{
    width: 85%;
    display: flex;
    justify-content: center;
    align-items: center;

    font-family: 'Rubik-Medium';
    font-size: 18px;
    line-height: 24px;
    color: white;
  }
`;

const BuddyTabContainer = styled.div`
display: flex;
width: 100%;
background: white;
border-radius: 6px;
.launchButton{
  display:flex;
  margin:auto;
  margin-right: 15px;
}
`;

const CategoryWrapper = styled.div`
display: flex;
width: 100%;
flex-wrap:wrap;
justify-content: flex-start;
margin-top: ${({margin}) => margin ? margin : '25px'};
`;

const CategoryCard = styled.div`
display:block;
width:calc((100% - 50px) / 3);
margin: ${({margin}) => margin ? margin : '0 0 25px 0'};
.image{
  height: 252px;
  width:100%;
  border-radius: 6px 6px 0 0;
  position: relative;
  >img{
    width:100%;
    height: 100%;
    cursor:pointer;
    border-radius: 6px 6px 0 0;
  }
}
  .imageBackground {
    position: absolute;
    top: 0;
    width: 100%;
    height: 252px;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px 6px 0 0;
    .viewMore {
      font-family: 'Lato';
      font-size: 16px;
      line-height: 20px;
      min-width: 200px;
      height: 40px;
      background: ${({background}) => background ? background : '#FD7175'};
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 6px;
      color: ${({color}) => color ? color : '#005c87'};
      text-align: center;
      padding: 0px 10px;
      gap:8px;
    }
  }
// }
.categoryNameWrapper{
  min-height:56px;
  border-radius: 0px 0px 6px 6px;
  background:white;
  display:flex;
  align-items: center;
  .activityIcon{
    display: flex;
    margin: auto;
    margin-right: 15px;
    >img{
      width:19px;
      height:24px;
    }
  }
  .wellnessActivityIcon{
    display: flex;
    margin: auto;
    margin-right: 15px;
    >img{
      width:24px;
      height:24px;
    }
  }
  .categoryName{
    max-width:75%;
    font-family: LAto;
    font-size: 18px;
    line-height: 24px;
    color: #184A61;
    padding-left: 16px;
    font-weight: 700;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    overflow: hidden;
  }
  .tooltipIcon{
     width:22px;
     height:22px; 
     margin-left:10px;
     >img{
         width:100%;
         height:100%;
         cursor:pointer;
     }

     .text{
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      display: -webkit-box;
      max-width: 100%;
      text-overflow: ellipsis;
     }
  }
  .challengeCount{
    font-family: Lato;
    font-size: 16px;
    line-height: 20px;
    color: #184A61;  
    margin:auto;
    margin-right:16px;  
  }
}
.wrapperMain{
  background:white;
  display:flex;
  border-radius: 0px 0px 6px 6px;
  flex-wrap:wrap;
  .adminCards{
    display:flex;
    width:100%;
    padding-bottom: 15px;
  }
.categoryNameWrapper{
  width:100%;
  min-height:54px;
  // border-radius: 0px 0px 6px 6px;
  background:white;
  display:flex;
  align-items: center;
  .challenge-title{
    width:100%;
    display:block;
    padding:16px;
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .categoryName{
    color:  #184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }
  .tooltipIcon{
     width:22px;
     height:22px; 
     margin-left:10px;
     >img{
         width:100%;
         height:100%;
         cursor:pointer;
     }
  }
  .challengeCount{
    font-family: Rubik;
    font-size: 14px;
    line-height: 20px;
    color: #F4AAA9;  
    margin:auto;
    margin-right:15px;  
  }
}
}
`;

const SeeAllStyledModal = styled(Modal)`
  .modal-dialog {
    width:500px;
    // height:400px;
    .modal-content{
      border-radius: 7px 7px 6px 6px;
    }
    .modal-header {
      background: linear-gradient(180deg,#52A8ED 0%,#8AD3F7 100%);
      border-radius: 6px 6px 0px 0px;
    }
    .modal-footer{
      height:80px;
      display:flex;
      justify-content:center;
      align-items:center;
      
    }
    .modal-body{
      padding: 0px 65px;
      width:100%;
      display:flex;
      justify-content:center;
      align-items:center;
      flex-direction:column;
    }  
`;

const CustomTitle = styled(Modal.Title)`
float: left;
width: 100%;
> div {
  float: left;
  width: 100%;
  display: flex;
  > div {
    font-size: 12px;
    color: #a9a9a9;
    display: flex;
  }

  > span {
    font-size: 18px;
    letter-spacing: 0px;
    font-family: rubik-medium;
    color: white;
    width: 70%;
  }
  .closeImage{
    width: 30%;
    display: flex;
    justify-content: flex-end;
    >img{
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}

@media (max-width: 500px) {
  padding: 0 10px;
}
`;

const PopupDetials = styled.div`
display: flex;
width: 100%;
flex-wrap:wrap;
.congrats{
  width:100%;
  text-align:center;
  font-family: Rubik-Medium;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color:#69c2ff;
  padding-top: 25px;
}
.congratssub{
  width:100%;
  font-family: Rubik;
font-size: 18px;
font-weight: 500;
line-height: 20px;
color:#002f47;
padding-top: 15px;
text-align:center;
}
.challengeName{
  width:100%;
  font-family: Rubik-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  color:#002f47;
  padding-top: 15px;
  text-align:center;
  padding: 25px 0px
}
.challengeIcon{
  width:100%;
  height: 250px;
  border-radius:6px;
  >img{
    width:100%;
    height:100%;
    border-radius:6px;
  }
}
.cardWrapper{
  display:flex;
  width:100%;
  margin: 15px 0px 25px 0px;
  .categoryType{
    display:flex;
    align-items: center;
    .categoryImage{
      width:25px;
      height:25px;
      >img{
      width:25px;
      height:25px;}
    }
    .categoryName{
      font-family: Rubik-Medium;
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
      color:#002f47;
      margin-left:10px;
    }
  }
.question{
  background: #9c9c9c;
  border-radius:3px;
  padding: 5px 10px;
  display: flex;
    margin: auto;
    margin-right: 0px;
  .text{
    font-family: Rubik-Medium;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    color:#69c2ff;
  }
}
}
`;

const TabsWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const TabsButton = styled.div`
  display: flex;
  width: 100%;
  width: ${({width}) => width ? width : '100%'};
  height: ${({height}) => height ? height : '100%'};
  background:${({background}) => background ? background : 'transparent'};
  border:${({border}) => border ? border : '1px solid #005C8799'};
  color:${({color}) => color ? color : 'white'};
  font-family:${({font}) => font ? font : 'Rubik'};
  font-size: 16px;
  line-height: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  margin:${({margin}) => margin ? margin : '0'};
`;

const PopupWrapper = styled.div`
 width:100%;
 display:flex;
 border-bottom: 1px solid #005C874D;
 background:white;
 flex-wrap:wrap;
 .heading{
  font-family: Rubik-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: #005C87;
  width:100%;
  display:flex;
  justify-content:center;
  padding: 25px 25px 15px 25px;
 }
 .about{
  font-family: Rubik-Medium;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  color: #0D4270;
  width:100%;
  display:flex;
  justify-content:center;
  padding: 0px 25px 15px 25px;
 }
 .image{
  width:100%;
  margin-bottom:15px;
  >img{
    width:320px;
    height:200px;
    border-radius:6px;
    margin: auto;
    display: flex;
  }
 }
 .type{
  width:100%;
  display:flex;
  justify-content:center;
  margin-bottom:15px;
  >img{
   width:20px;
   height:24px;
  }
  .name{
    font-family: Rubik;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: center;
    color:#0D4270;
    margin-left:10px;
    align-items:center;
    display:flex;
  }
 }
.aboutChallenge{
  padding:0 25px 5px 25px;
  width:100%;
  justify-content:center;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  color:#0D4270;
}
`;

const ButtonWrapper = styled.div`
width:100%;
display:flex;
padding:0 25px 0 25px;
justify-content: center;
.button{
width: ${({ width, widthValue }) => (widthValue?widthValue:width ? "48%" : "100%")};
font-size: 18px;
font-size: ${({ font }) => (font ? font : "18px")};
line-height: 24px;
font-family: rubik-medium;
color: ${({ disabled }) => (disabled ? 'white' : "white")};
padding: 13px 8px 13px 8px;
padding: ${({ padding }) => (padding ? padding : "13px 8px 13px 8px")};
display: flex;
margin: ${({ margin }) => (margin ? margin : "15px")};
justify-content: center;
border-radius: 3px;
cursor: ${({ cursor }) => (cursor ? "" : "pointer")};
background: ${({ disabled }) =>disabled ? '#005C874D' : "#005C87"};
box-shadow: ${({ disabled }) => (disabled ? '' : "0px 8px 24px 0px #005C8780")};
}
`;

const CreateChallengeCard = styled.div`
width: calc((100% - 50px) / 3);
display:flex;
height:303px;
border: 3px dashed #005C874D;
border-radius:6px;
.button{
  width: 239px;
  height: 50px;
  display:flex;
  margin:auto;
  background: #005C87;
  border-radius:6px;
  font-family: Rubik-Medium;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: white;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}
`;

const CreateChallengeButton = styled.div`
  display: flex;
  width: 190px;
  height:40px;
  border: 1px solid #005C87;
  background: ${({ active }) =>active ? '#005C87' : "transparent"};
  border-radius:6px;
  margin:auto 0px auto auto;
  cursor:pointer;
  .image{
    height:22px;
    width:22px;
    margin:auto 0px auto 10px;
    >svg{
      height:22px;
      width:22px;
      >path{
        fill: ${({ active }) =>active ? 'white' : "#005C87"};
      }
    }
  }
  .text{
    font-family: Rubik-Medium;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    color: ${({ active }) =>active ? 'white' : "#005c87"};
    display:flex;
    justify-content:center;
    align-items:center;
    margin: auto;
  }
`;



const ChallengesCategoryCard = styled.div`
display: flex;
width: 400px;
height: 336px;
padding: 0 100px;
justify-content: center;
align-items: center;
border-radius: 4px;
border: 1px dashed  #BDBDBD;
`;


const FlexWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px; 
`;


const NewChampionsCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: calc((100% - 50px) / 3);
  border-radius: 6px;
  margin-right: ${({ margin }) => margin?margin:""};
  @media(max-width: 600px) {
    width: 100%;
  }
  > div {
    padding: 5px;
    height: 100%;
  
  }

  .flex-item:not(:nth-child(3n)) {
  margin-right: 0;
}
&:nth-child(3n){
    margin-right: 0;
  }

  .recommended-survey{
    .flex-item:not(:nth-child(3n)) {
  margin-right: 0;
}
  }
`;


const EventCard = styled.div`
  background-color: rgba(254, 254, 254, 0.60);
  float: left;
  border-radius: 4px;
  margin-bottom: ${({ isMarginBottom }) => isMarginBottom ? isMarginBottom : '25px'};
  ${'' /* margin-bottom: 25px; */}
  padding: 0px!important;
  //width: 100%;
  width: 400px;
  height: 308px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  // box-shadow: 0px 8px 25px 0px #0D427040;
  img {
    width: 100%;
    height: 250px;
    float: left;
    cursor:pointer;
  }

  .educateImageBackground {
    position: absolute;
    top: 0;
    width: 100%;
    height: 250px;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px 6px 0 0;
    .getStarted {
      font-family: 'Lato';
      font-weight: 400;
      font-size: 16px;
      font-style: normal;
      width: 200px;
      height: 40px;
      line-height: 20px;
      gap: 8px;
      background: #DA6C74;
      color: #FEFEFE;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      cursor: pointer;
      text-align:center;
      align-items: center;
      padding: 12px 16px;
      >img{
        width:24px;
        height:24px;
        margin-right:12px;
      }
    }
  }
`;


const NewVideoPlayer = styled.div`
  width: 100%;
  float: left;
  height: ${({ height }) => height ? height : '250px'};
  text-align: center;
  cursor: pointer;
  position: relative;

  > div {
    width: 100% !important;
    height: 100% !important;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: ${({ radius }) => radius && '6px'};
    @media (max-width: 1200px) {
      width: auto;
    }
  }

  ${({ wellnessDashboard }) => wellnessDashboard && css`
    img {
      max-width: 400px;
    }
  `}
  @media (max-width: 500px){
    height: 200px;
  }
  .title{
    font-size: 18px;
    text-transform: Capitalize;
    width: 100%;
    float: left;
    text-align: left;
    position: absolute;
    font-family: Lato;
    top: 25px;
    left: 35px;
    color: #FFFFFF;
    width: auto !important;
    height: unset !important;
  }
  .bg-opacity {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.329545);
    border-radius: 6px;
  } 
`;



const NewContentV2 = styled.div`
  display: flex;
  align-items: flex-start; /* top align */
  justify-content: space-between;
  width: 100%;
  min-height: 75px;
  padding: 16px;

  .firstContainer {
    flex: 1 1 0;
    min-width: 0;
    margin-right: ${({ isMargin }) => isMargin ? isMargin : '16px'};

    .name {
      font-family: 'Lato';
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      color: #184A61;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .categoryName {
      font-family: 'Lato';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #184A61;
      margin-top: 8px;
      text-transform: capitalize;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }


    .monthName{
      color: var(--Font-Color-on-Light-theme-500, #184A61);
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; 
    }
  }
`;



export { LaunchchallengeButton, BuddyTabContainer, CategoryWrapper, CategoryCard, CustomTitle, SeeAllStyledModal, PopupDetials, TabsWrapper, TabsButton, PopupWrapper, ButtonWrapper, CreateChallengeCard, CreateChallengeButton,ChallengesCategoryCard,FlexWrapper,NewChampionsCard,EventCard,NewVideoPlayer,NewContentV2 }